import { transparentize } from "polished";
import { ReactNode } from "react";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";
import tw from "src/utils/tw";

interface Props {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

export default function FilterBarButton(props: Props) {
  const store = useStore();

  return (
    <button
      onClick={props.onClick}
      className={tw(
        "mr-2 h-8 whitespace-nowrap rounded border px-3 text-xs uppercase tracking-widest transition",
        props.active
          ? "border-organization text-organization"
          : "border-borderGray text-empty",
        props.className
      )}
      css={{
        backgroundColor: props.active
          ? transparentize(0.9, store.theme.orgColor)
          : colors.borderGray,
      }}
    >
      <strong>{props.children}</strong>
    </button>
  );
}
